module.exports = __webpack_public_path__ + "static/media/restroom.a38657e7.svg";